import React from 'react';
import cx from 'classnames';
import { COPY_STRINGS } from '../../../constants/translatedCopy';

export default class SplitItem extends React.Component {

  render() {
    let containerClasses = cx({
      'exampleItemContainer': this.props.isInstruction,
      'splitItemContainer': true,
      'testItemContainer': true,
    });

    let wordContainerClasses = cx({
      'example': this.props.isInstruction,
      'splitItem' : true,
      'outlined' : true,
    });

    return (
      <div className={containerClasses}>
        {this.props.isInstruction && <div className="exampleIndicator">{COPY_STRINGS.example}:</div>}
        <div className={wordContainerClasses}>
          <div className="leftItem">{this.props.left}</div>
          <div className="rightItem">{this.props.right}</div>
        </div>
      </div>
    );
  }
}
